import { AdminEffects } from './admin.effects';
import { AppEffects } from './app.effects';
import { ShareholderEffects } from './shareholder.effects';

export const effects: any[] = [AdminEffects, AppEffects, ShareholderEffects];

export * from './admin.effects';
export * from './app.effects';
export * from './shareholder.effects';
